import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../contexts/AuthContext";
import { Sparkle } from "@phosphor-icons/react";

export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/login", { replace: true });
      return;
    }
    const sessionId = match[1];

    (async () => {
      try {
        const params = new URLSearchParams(location.search || "");
        const expectedEmail = (params.get("expected_email") || "").trim().toLowerCase();
        const payload = expectedEmail
          ? { session_id: sessionId, expected_email: expectedEmail }
          : { session_id: sessionId };
        const res = await api.post("/auth/session", payload);
        setUser(res.data.user);
        // clean URL + go to dashboard
        window.history.replaceState({}, "", "/dashboard");
        navigate("/dashboard", { replace: true, state: { user: res.data.user } });
      } catch (err) {
        // 403 = allowlist denial. Bounce back to the landing with the modal
        // pre-opened in the denial state (kind + message).
        const status = err?.response?.status;
        const detail = err?.response?.data?.detail;
        if (status === 403 && detail && typeof detail === "object") {
          const kind = encodeURIComponent(detail.kind || "not_invited");
          const msg = encodeURIComponent(detail.message || "");
          navigate(`/?denied=${kind}&msg=${msg}`, { replace: true });
          return;
        }
        navigate("/login", { replace: true });
      }
    })();
  }, [location.search, navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="flex items-center gap-3 text-[#a1a1a1]">
        <Sparkle size={18} color="#5e50f7" weight="fill" className="animate-pulse" />
        Bejelentkezés folyamatban...
      </div>
    </div>
  );
}
